import { render, staticRenderFns } from "./ContentArea.vue?vue&type=template&id=10c4ab62&"
import script from "./ContentArea.vue?vue&type=script&lang=js&"
export * from "./ContentArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c4ab62')) {
      api.createRecord('10c4ab62', component.options)
    } else {
      api.reload('10c4ab62', component.options)
    }
    module.hot.accept("./ContentArea.vue?vue&type=template&id=10c4ab62&", function () {
      api.rerender('10c4ab62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/ContentArea.vue"
export default component.exports